<template>
  <div class="cx-tooltip">
    <div class="content" @mouseenter.stop="showTip($event)" @mouseleave.stop="hideTip($event)">
      <slot></slot>
    </div>
    <span ref="tips" v-if="showToolTip" class="tips" :class="placement">{{ content }}</span>
  </div>
</template>

<script>
export default {
  name: "cxTooltip",
  props: {
    content: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      required: false,
      default: "top"
    }
  },
  data() {
    return {
      showToolTip: true
    }
  },
  methods: {
    showTip() {
      this.showToolTip = true
      setTimeout(() => {
        this.$refs.tips?.classList.add("show")
      }, 0)
    },
    hideTip() {
      this.$refs.tips?.classList.remove("show")
      setTimeout(() => {
        this.showToolTip = false
      }, 300)
    }
  }
}
</script>
<style scoped>
.cx-tooltip {
  position: relative;
}
.cx-tooltip .tips {
  display: none;
  position: absolute;
  height: 36px;
  line-height: 36px;
  min-width: 40px;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 2;
  top: -46px;
  left: 50%;
  color: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  padding: 0 10px;
  font-size: 12px;
  word-break: keep-all;
  transition: opacity 0.2s linear 0.2s;
  opacity: 0;
}
.cx-tooltip .tips.show {
  opacity: 1;
  display: block;
}
.tips.bottom:before,
.tips.top:before ,
.tips.top-end:before {
  display: block;
  content: "";
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.8) transparent transparent;
}
.tips.top-end {
  left: auto;
  right:0;
  transform:none;
}
.tips.top-end:before {
  bottom: -12px;
  left: auto;
  right: 2px;
}
.tips.bottom {
  top: auto;
  bottom: -48px;
}
.tips.bottom:before {
  top: -12px;
  bottom: auto;
  border-color: transparent transparent  rgba(0, 0, 0, 0.8);
}
</style>
